<template>
    <div class="slide slide-section">

        <div class="back" @click="GoBack">
            <img src="/assets/img/icon-arrow-left-white.svg" />
        </div>

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-white.svg" />
        </div>

        <div class="text-title">
            Let’s get started<br>with finances.
        </div>

    </div>
</template>

<script>
export default {
    name: 'SectionTwo',
    methods: {
        GoBack() {
            this.$router.go(-1);
        },
        next() {
            this.$router.push({ name: 'Goals' });
        }
    }
}
</script>